import React from 'react';
import { FORMAT_TEXT_COMMAND } from 'lexical';
import { WBIconButton, WBSvgIcon } from '@admiin-com/ds-web';
import BoldIcon from '../../../../../assets/icons/document-editor/type-bold.svg';
import ItalicIcon from '../../../../../assets/icons/document-editor/type-italic.svg';
import UnderlineIcon from '../../../../../assets/icons/document-editor/type-underline.svg';
import StrikethroughIcon from '../../../../../assets/icons/document-editor/type-strikethrough.svg';
import { LexicalEditor } from 'lexical';
import { VerticalDivider } from '../DocumentEditor.styles';

interface FormatControlsProps {
  editor: LexicalEditor;
  isBold: boolean;
  isItalic: boolean;
  isUnderline: boolean;
  isStrikethrough: boolean;
}

export const FormatControls: React.FC<FormatControlsProps> = ({
  editor,
  isBold,
  isItalic,
  isUnderline,
  isStrikethrough,
}) => {
  return (
    <>
      <WBIconButton
        size="small"
        onMouseDown={(e) => {
          e.preventDefault();
          editor.dispatchCommand(FORMAT_TEXT_COMMAND, 'bold');
        }}
        sx={{
          backgroundColor: isBold ? 'primary.main' : 'transparent',
          color: isBold ? 'primary.contrastText' : 'inherit',
          '&:hover': {
            backgroundColor: isBold ? 'primary.dark' : 'action.hover',
          },
        }}
      >
        <BoldIcon />
      </WBIconButton>
      <WBIconButton
        size="small"
        onMouseDown={(e) => {
          e.preventDefault();
          editor.dispatchCommand(FORMAT_TEXT_COMMAND, 'italic');
        }}
        sx={{
          backgroundColor: isItalic ? 'primary.main' : 'transparent',
          color: isItalic ? 'primary.contrastText' : 'inherit',
          '&:hover': {
            backgroundColor: isItalic ? 'primary.dark' : 'action.hover',
          },
        }}
      >
        <ItalicIcon />
      </WBIconButton>
      <WBIconButton
        size="small"
        onMouseDown={(e) => {
          e.preventDefault();
          editor.dispatchCommand(FORMAT_TEXT_COMMAND, 'underline');
        }}
        sx={{
          backgroundColor: isUnderline ? 'primary.main' : 'transparent',
          color: isUnderline ? 'primary.contrastText' : 'inherit',
          '&:hover': {
            backgroundColor: isUnderline ? 'primary.dark' : 'action.hover',
          },
        }}
      >
        <UnderlineIcon />
      </WBIconButton>
      <WBIconButton
        size="small"
        onMouseDown={(e) => {
          e.preventDefault();
          editor.dispatchCommand(FORMAT_TEXT_COMMAND, 'strikethrough');
        }}
        sx={{
          backgroundColor: isStrikethrough ? 'primary.main' : 'transparent',
          color: isStrikethrough ? 'primary.contrastText' : 'inherit',
          '&:hover': {
            backgroundColor: isStrikethrough ? 'primary.dark' : 'action.hover',
          },
        }}
      >
        <StrikethroughIcon />
      </WBIconButton>
      <VerticalDivider orientation="vertical" flexItem />
    </>
  );
};
